module.exports = __webpack_public_path__ + "media/src/StayPackage/images/calendar-2e6d4805fed10d6ee15f5f6da8ec2570.svg";